import createSetBookedReservation from './setBookedReservation';
import { bookedReservationVar } from '../reactiveVariables';

const setBookedReservation = createSetBookedReservation(bookedReservationVar);

export default setBookedReservation;
